const DEFAULT_SUPABASE_URL = "https://blzsymavaecxvquezkup.supabase.co";
const DEFAULT_SUPABASE_ANON_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJsenN5bWF2YWVjeHZxdWV6a3VwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI1NjI3OTgsImV4cCI6MjA4ODEzODc5OH0.0nSaQOoS816SsOdOANY4nZYROfJGwKXnUAAKwYSRxFk";

const readOptionalEnv = (
  name: "SUPABASE_URL" | "SUPABASE_ANON_KEY",
): string | undefined => {
  const value = process.env[name]?.trim();
  return value ? value : undefined;
};

// Supabase anon keys are public client configuration. Zuplo's hosted docs build
// does not inject branch env vars into zudoku.config.tsx, so the portal needs
// checked-in defaults to build deterministically.
export const portalSupabaseConfig = {
  url: readOptionalEnv("SUPABASE_URL") ?? DEFAULT_SUPABASE_URL,
  anonKey: readOptionalEnv("SUPABASE_ANON_KEY") ?? DEFAULT_SUPABASE_ANON_KEY,
} as const;
